import { render, staticRenderFns } from "./SBreadcrumb.vue?vue&type=template&id=023f2846"
import script from "./SBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports